import { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useFetch } from '../../../hooks/useFetch';
import { EmployeeApiFactory } from '../api/employeeApi';
import type { EmployeeFilterOptions } from '../api/employeeApi';
import { normalizeLocale } from '../../../lib/locale';

export function useEmployeeFilterOptions(): EmployeeFilterOptions | undefined {
  const [client] = useFetch();
  const api = useMemo(() => EmployeeApiFactory(client), [client]);
  const { i18n } = useTranslation();
  const [options, setOptions] = useState<EmployeeFilterOptions | undefined>(undefined);

  useEffect(() => {
    const ctrl = new AbortController();
    api
      .getFilterOptions(normalizeLocale(i18n.language), { signal: ctrl.signal })
      .then(setOptions)
      .catch(() => {
        if (ctrl.signal.aborted) return;
        setOptions(undefined);
      });
    return () => ctrl.abort();
  }, [api, i18n.language]);

  return options;
}
